import React from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { LoadInfoStyled } from "./loadInfo.styles";

import {
  selectNewRequestLoadTypes,
  selectNewRequestLoadDescLoad,
  selectNewRequestSelectedLoadType,
} from "../../redux/newRequest/newRequest.selectors";
// import ArrowDownIcon from "../../assets/img/arrowDownIcon";

import ReactSelect from "react-select";
import {
  setLoadDescLoad,
  setSelectedLoadType,
} from "../../redux/newRequest/newRequest.actions";

// import "node_modules/react-selectize/themes/index.css";

const LoadInfo = ({
  dark,

  selectNewRequestLoadTypes,
  selectNewRequestLoadDescLoad,
  selectNewRequestSelectedLoadType,

  setLoadDescLoad,
  setSelectedLoadType,
}) => {
  let options = [
    { value: "chocolate", label: "Chocolate" },
    { value: "strawberry", label: "Strawberry" },
  ];
  // useEffect(() => {
  let ooo = [];

  for (let i = 0; i < selectNewRequestLoadTypes.length; i++) {
    ooo[i] = {
      value: selectNewRequestLoadTypes[i].tname,
      label: selectNewRequestLoadTypes[i].tname,
    };
  }

  options = ooo;
  // return () => {
  //   cleanup
  // }
  // }, []);

  console.log(selectNewRequestLoadTypes);
  // debugger;

  const handle_desc_change = (e) => {
    const value = e.currentTarget.value;

    setLoadDescLoad(value);
  };

  const handle_reactSelect_change = (e) => {
    // alert("hi");
    const target = selectNewRequestLoadTypes.find(
      (item) => item.tname === e.value
    );
    setSelectedLoadType(target._id);
  };

  const selectValue = () => {
    const xxx = selectNewRequestLoadTypes.find(
      (item) => item._id === selectNewRequestSelectedLoadType
    );
    console.log("selectNewRequestLoadTypes",selectNewRequestSelectedLoadType)

    return xxx ? { value: xxx.tname, label: xxx.tname } : "";
  };

  return (
    <LoadInfoStyled dark>
      <div className="position-relative">
        {/* <datalist id="loads">
          {selectNewRequestLoadTypes.length &&
            selectNewRequestLoadTypes?.map(({ tname, _id }) => (
              <option key={_id} value={tname}>
                {tname}
              </option>
            ))}
        </datalist>
        <input
          type="text"
          list="loads"
          title="نوع بار خود را بنویسید"
          id="load-selector"
          placeholder="نوع بار"
          className="input"
        /> */}

        <ReactSelect
          // value={[1, 2, 3]}
          // onChange={this.handleChange}
          placeholder="نوع بار ..."
          options={options}
          className={`react-select ${dark && "mt-3"}`}
          noOptionsMessage={({ inputValue: string }) => "یافت نشد"}
          onChange={handle_reactSelect_change}
          value={selectValue()}
        />
        {/* <div className="down-arrow">
          <ArrowDownIcon size="19" color="black" />
        </div> */}
      </div>

      <div>
        <textarea
          className="text-area"
          name=""
          id=""
          cols="30"
          rows="2"
          placeholder="شرح بار"
          onChange={handle_desc_change}
          value={selectNewRequestLoadDescLoad}
        ></textarea>
      </div>
    </LoadInfoStyled>
  );
};

const mapStateToProps = createStructuredSelector({
  selectNewRequestLoadTypes: selectNewRequestLoadTypes,
  selectNewRequestLoadDescLoad: selectNewRequestLoadDescLoad,
  selectNewRequestSelectedLoadType: selectNewRequestSelectedLoadType,
});
const mapDispatchToProps = (dispatch) => ({
  setLoadDescLoad: (x) => dispatch(setLoadDescLoad(x)),
  setSelectedLoadType: (x) => dispatch(setSelectedLoadType(x)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LoadInfo);
